import request from '@/utils/request';

export const getPlayerStatList = data => request({
  url: '/v1/topic/playerStatList',
  data:{leagueId: process.env.VUE_APP_LEAGUEID, ...data},
})



